import { Component, Input, ViewEncapsulation } from '@angular/core';

export type IconType = 'success' | 'warning' | 'danger' | 'info';

@Component({
  selector: 'app-status-item',
  templateUrl: './status-item.component.html',
  styleUrl: './status-item.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class StatusItemComponent {
  @Input() iconType: IconType = 'info';
  @Input() iconClass: string = '';
  @Input() divider: boolean = false;
}
